import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { City } from '../model/City.model';
import { URL_API } from './url.api';
import { State } from '../model/State.model';

@Injectable({
  providedIn: 'root'
})
export class CityService {

  constructor(
    private http: HttpClient
  ) { }

  save(c: City): Observable<any> {
    return this.http.post<any>(`${URL_API}/cities`, c);
  }
  
  findByState(state: any): Observable<Array<City>> {
    return this.http.get<Array<City>>(`${URL_API}/cities/state/${state.id}`);
  }

  findAll(): Observable<Array<City>> {
    return this.http.get<Array<City>>(`${URL_API}/cities`);
  }

  findStateOfCities(): Observable<Array<State>> {
    return this.http.get<Array<State>>(`${URL_API}/cities/states`);
  }

  findStates(): Observable<Array<State>> {
    return this.http.get<Array<State>>(`${URL_API}/states`);
  }

}
